<script lang="ts" setup>
import ButtonIcon from '@/shared/components/UI/Buttons/ButtonIcon.vue';
import IconChevron from '@/shared/components/UI/Icons/IconChevron.vue';

defineEmits<{
  (e: 'prev-gallery'): void;
  (e: 'next-gallery'): void;
}>();

defineProps<{
  labelPrev: string;
  labelNext: string;
}>();
</script>
<template>
  <div ref="root" class="relative size-full p-14">
    <ButtonIcon
      theme="light"
      :label="labelPrev"
      size="md"
      class="absolute left-2 top-1/2 -translate-y-1/2"
      @click="$emit('prev-gallery')"
    >
      <IconChevron direction="left" class="text-2xl" />
    </ButtonIcon>
    <slot />

    <ButtonIcon
      theme="light"
      :label="labelNext"
      size="md"
      class="absolute right-2 top-1/2 -translate-y-1/2"
      @click="$emit('next-gallery')"
    >
      <IconChevron direction="right" class="text-2xl" />
    </ButtonIcon>
  </div>
</template>
